"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
function isBatch(message) {
    return message.messageType === constants_1.MESSAGE_BATCH;
}
exports.isBatch = isBatch;
function isBroadcast(message) {
    return message.messageType === constants_1.MESSAGE_BROADCAST;
}
exports.isBroadcast = isBroadcast;
function isPost(message) {
    return message["postType"] !== undefined;
}
exports.isPost = isPost;
function isPostRequest(message) {
    return isPost(message) && (message.messageType === constants_1.MESSAGE_REQUEST);
}
exports.isPostRequest = isPostRequest;
function isPostResponse(message) {
    return isPost(message) && (message.messageType === constants_1.MESSAGE_RESPONSE);
}
exports.isPostResponse = isPostResponse;
function isRequest(message) {
    return message.messageType === constants_1.MESSAGE_REQUEST;
}
exports.isRequest = isRequest;
function isResponse(message) {
    return message.messageType === constants_1.MESSAGE_RESPONSE;
}
exports.isResponse = isResponse;
